
import {
  RequestBase, RequestBaseIds, RequestBasePageIds, RequestBaseSet, RequestDelete
  , RequestDeleteIds, ResponseBase, ResponseBasePage, ResponseBaseSet, TreeDataItem
} from "src/app/modules/fwcore/models";
import { Category, ModelValue, ValueControlType, ValueDataType, ValueUnit } from "src/app/features/prob/models";

export class RequestModelValueTree extends RequestBaseIds<string> {

  /**
 * The identifier of the deal group to filter model values by.
 */
  dealGroupId?: string | null;

  /**
   * The identifier of the deal type to filter model values by.
   */
  dealTypeId?: string | null;


}

export class ResponseModelValueTree extends ResponseBaseSet<TreeDataItem> {
}

export class RequestModelValue extends RequestBasePageIds {

  /**
 * The identifier of the deal group to filter model values by.
 */
  dealGroupId?: string | null;

  /**
   * The identifier of the deal type to filter model values by.
   */
  dealTypeId?: string | null;

  /**
   * The identifier of the deal item to filter model values by.
   */
  dealItemId?: string | null;

  /**
   * Indicates whether all model values should be included (null) or match if active or not.
   */
  isActive?: boolean | null = null;

  /**
   * Indicates whether to include only model values that have Excel support.
   */
  hasExcel?: boolean | null = null;

  /**
   * Filter the list to deal values that have been assigned to the specified category IDs.
   */
  categoryIds?: [string] | null;

  /**
   * Filter the list to deal values that have been assigned to the specified category codes.
   */
  categoryCodes?: [string] | null;

}

export class ResponseModelValue extends ResponseBasePage<ModelValue> {
}

export class RequestModelValueSet extends RequestBaseSet<ModelValue> {
}

export class ResponseModelValueSet extends ResponseBaseSet<ModelValue> {
}

export class RequestModelValueDelete extends RequestDeleteIds {

  hardDelete?: boolean | null = null;
}

/**
 * Request child data collections for Model Values
 */
export class RequestModelValueDataCollections extends RequestBase {

}

/**
 * Return child data collections for Model Values
 */
export class ResponseModelValueDataCollections extends ResponseBase {

  /**
   * Gets the types of data that are supported by model values.
   */
  dataTypes?: ValueDataType[] | null;

  /**
   * Gets the control types that the UI can utilize to distinguish which controls to generate for visualization.
   */
  controlTypes?: ValueControlType[] | null;

  /**
   * Gets the available categories that can be used for additional processing.
   */
  categories?: Category[] | null;

  /**
   * Gets the display unit hint.
   * This is used to help the UI determine how to display the value.
   * The value stored will always be in its original full value.
   * Currently, not supported 4 Feb 2025.
   */
  units?: ValueUnit[] | null;
}

export class RequestModelValueReorder extends RequestBase {

  id?: string | null = null;
  moveUp?: boolean | null = null;
  parentId?: string | null = null;
}

export class ResponseModelValueReorder extends ResponseBase {

}

export class RequestModelValueCopyPaste extends RequestBase {

  /**
   * Gets or sets the deal type identifier from where we are copying from.
   */
  copyFromDealTypeId?: string | null = null;

  /**
   * Gets or sets the deal group identifier from where we are copying from.
   */
  copyFromDealGroupId?: string | null = null;

  /**
   * Gets or sets the deal type identifier from where we are copying to.
   */
  copyToDealTypeId?: string | null = null;

  /**
   * Gets or sets the deal group identifier from where we are copying from.
   */
  copyToDealGroupId?: string | null = null;

  /**
   * Gets or sets the model value identifier from where we are copying from.
   */
  copyModelValueBranchId?: string | null = null;

  /**
   * Gets or sets the model value identifier from where we are copying to can be null for top level.
   */
  copyToModelValueBranchId?: string | null = null;
}

export class ResponseModelValueCopyPaste extends ResponseBase {

}
